import { DatePipe, DecimalPipe, ViewportScroller } from '@angular/common';
import { JsonpClientBackend } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ɵɵsetComponentScope,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActiveTaxList } from 'src/app/shared/entities/ActiveTaxList';
import { AddedAdjustments } from 'src/app/shared/entities/AddedAdjustments';
import { AddedRevenue } from 'src/app/shared/entities/AddedRevenue';
import { AddedRevenueValidation } from 'src/app/shared/entities/AddedRevenueValidation';
import { AdjustmentsCompletedGB } from 'src/app/shared/entities/AdjustmentsCompletedGB';
import { AdjustmentsCompletedMI } from 'src/app/shared/entities/AdjustmentsCompletedMI';
import { AdjustmentValidation } from 'src/app/shared/entities/AdjustmentValidation';
import { AppliedPayment } from 'src/app/shared/entities/AppliedPayment';
import { InvoiceAdjustmentReasons } from 'src/app/shared/entities/InvoiceAdjustmentReasons';
import { InvoiceAdjustments } from 'src/app/shared/entities/InvoiceAdjustments';
import { InvoiceNegativeBalance } from 'src/app/shared/entities/InvoiceNegativeBalance';
import { InvoicePayment } from 'src/app/shared/entities/InvoicePayment';
import { InvoicePaymentWithExpectedDepositDate } from 'src/app/shared/entities/InvoicePaymentWithExpectedDepositDate';
import { PaidInvoicePayments } from 'src/app/shared/entities/PaidInvoicePayments';
import { PaymentTypes } from 'src/app/shared/entities/PaymentTypes';
import { paymentValidation } from 'src/app/shared/entities/paymentValidation';
import { PendingPayment } from 'src/app/shared/entities/PendingPayment';
import { ProcessedInvoicePayments } from 'src/app/shared/entities/ProcessedInvoicePayments';
import { QuickSearchCriteria } from 'src/app/shared/entities/QuickSearchCriteria';
import { QuickSearchResults } from 'src/app/shared/entities/QuickSearchResults';
import { RevenueHistoricalPostAdjustments } from 'src/app/shared/entities/RevenueHistoricalPostAdjustments';
import { RevenuePostAdjustmentQuery } from 'src/app/shared/entities/RevenuePostAdjustmentQuery';
import { RevenuePostAdjustments } from 'src/app/shared/entities/RevenuePostAdjustments';
import { RevenueTypes } from 'src/app/shared/entities/RevenueTypes';
import { TaxListMatchingInvoiceDate } from 'src/app/shared/entities/TaxListMatchingInvoiceDate';
// import { UserData } from '../code/helpers/userData';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { LotService } from 'src/app/core/services/data/lot.service';
import { AdjustmentService } from 'src/app/core/services/data/adjustment.services';
import { UserService } from 'src/app/core/services/auth-security/user.service';
import { ConfirmSubmitPaymentComponent } from '../dialog/confirm-submit-payment.component';
import { QuicksearchService } from 'src/app/core/services/data/quicksearch.service';
import { withLatestFrom } from 'rxjs';
import { MessageService } from 'src/app/core/services/broadcast/message-service';
import { ApnUtilitiesService } from 'src/app/core/services/data/apn-utilities.service';
import { dbErrorEntry } from 'src/app/shared/entities/dbErrorEntry';
import { ErrorMessagesComponent } from '../dialog/error-messages.component';
import { environment } from 'src/environments/environment';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { IRestrictedCharsError, ISettingsState } from 'src/app/shared/interfaces';
import { DialogInvalidReferenceNumberComponent } from 'src/app/core/dialog/dialog-invalid-reference-number/dialog-invalid-reference-number.component';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { FindByInvoiceNumberComponent } from 'src/app/feature/search-snacks-home/find-by-invoice-number/find-by-invoice-number.component';
import { SandboxService } from 'src/app/core/services/data/sandbox.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IssueDataService } from 'src/app/core/services/data/issue-data.service';

type NewType = PaymentTypes;

@Component({
  selector: 'app-quick-search-results',
  templateUrl: './quick-search-results.component.html',
  styleUrls: ['./quick-search-results.component.scss'],
})
export class QuickSearchResultsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  readonly PAYMENT_TYPE_OPTION_HEADER: string = '-- SELECT PAYMENT TYPE --';
  urlDomain: string = '';
  @Input() quickSearchCriteria: QuickSearchCriteria;
  //userData: UserData = new UserData();
  quickSearchResults: QuickSearchResults[] = [];
  //sortedQuickSearchResults: QuickSearchResults[];

  paymentTypes: NewType[] = [];
  revenueTypes: RevenueTypes[] = [];
  invoicePayments: PaidInvoicePayments[] = [];
  activeTaxListForLot: ActiveTaxList[] = [];
  matchingTaxListForInvoice: TaxListMatchingInvoiceDate[] = [];
  processedInvoicePaymentStatus: ProcessedInvoicePayments[] = [];
  rowsReturned: number = 0;
  //displayColumns: string[] = ['invoiceDate','invoiceNumber', 'rate', 'cardNo', 'customerName', 'companyName', 'created', 'dueDate', 'delivery', 'dateSent', 'paymentType', 'paymentAmount','referenceNumber', 'adjustmentAmount', 'currentBalance', 'transactionDate', 'options' ];
  paymentEnabled: string = '';
  pendingPayments: PendingPayment[] = [];
  appliedPayments: AppliedPayment[] = [];
  revenuePostAdjustments: RevenueHistoricalPostAdjustments[] = [];
  markForPayment: number = -1;
  paymentQueued: boolean = false;
  referenceNumber: string = '';
  gridMode: boolean = false;
  querySubscription: Subscription;
  defaultPaymentType: string = '';
  referenceNumberPlaceholder: string = '';
  referenceNumberErrorMessage: string = ''; //this displays the error message for reference number input format
  selectedPaymentIndex: number = 0;
  enableModeSubscription: Subscription;
  invoiceDetail: QuickSearchResults = new QuickSearchResults();
  currentUserName: string;
  isGB: boolean;
  queryInvoiceLineItemSubscription: Subscription;
  invoiceDetailsForNewBalances: QuickSearchResults;
  areBatchPaymentsProcessing: boolean = false;
  batchInvoiceErrorMessage: string = '';
  showAllGridColumns: boolean = true;
  gridFontSize: number = 12;
  currentlyActivePaymentRow: number = -1;
  onRowChange: number = 0;
  gridViewSelection: number = 0; //This is the value for what column view will be displayed
  refNumberErrorCount: number = 0;
  readonly sendInvoicesTabIndex: number = 2;
  readonly sendInvoicesMinSpinnerMs: number = 1000;
  isSendInvoicesTabSelected: boolean = false;
  isSendInvoicesTabLoading: boolean = false;
  hasSendInvoicesFormRendered: boolean = false;
  isSendInvoicesChildLoading: boolean = false;
  private sendInvoicesSpinnerStartTimestamp: number = 0;

  /* * * * 
  Payment Form Variables
  * * * */
  //  workingInvoicePeriod: string = '';
  //  workingInvoiceNumber: string = '';
  //  workingCustomerName: string = '';
  //  workingInvoiceAmount: number = 0;
  //  workingInvoiceBalance: number = 0;
  //  paymentFormDepositDate: string = '';
  pmtComment: string = '';
  pmtAmount: number = 0;
  pmtReferenceNumber: string = '';
  pmtTypeText: string = '';
  pmtTypeCode: string = '';
  pendingDirectDepositPayment: InvoicePaymentWithExpectedDepositDate = new InvoicePaymentWithExpectedDepositDate();
  paymentDataIsInvalid: boolean = true;
  referenceNumberPlaceholderForm: string = '';
  paymentValidationMessages: paymentValidation = new paymentValidation();

  /* * * * Added Revenue Form Variables * * * */
  appliedRevenue: AddedRevenue[] = [];
  totalCalcedAddedRevenue: number = 0;
  subtotalCalcedAddedRevenue: number = 0;
  currentRevenueRate: number = 0;
  addedRevenueQuantity: number = 0;
  addedRevenueRate: number = 0;
  invoiceAdjustments: InvoiceAdjustments[] = [];
  invoiceAdjustmentReasons: InvoiceAdjustmentReasons[] = [];
  maximumAdjustmentAmount: number;
  adjustmentCurrentDate: Date = this.getCurrentDate();
  addRevenueIsTaxableCheckBox: boolean = true;
  taxableRevenueShouldBeApplied: boolean = true;
  baseTaxToCalcFrom: number = 0;
  totalTaxRate: number = 0;
  calcTaxAmount: number = 0;
  calcTotalAmount: number = 0;
  calcRate: number = 0;
  netTaxAmount: number = 0;
  revenueDescription: string = '';
  showRevenuePostAdjustment: boolean = false;
  postAdjustmentRevenueAdjustmentId: number = 0;
  revenuePostAdjustmentAmount: number = 0;
  revenuePostAdjustmentData: RevenuePostAdjustments;
  submitRevenueValidated: boolean = true;
  flagDisablePostRevenueAdjustmentButton: boolean = true;
  addedRevenueValidation: AddedRevenueValidation = new AddedRevenueValidation();
  rowSelectedOnGrid: number = -1;

  /* * * * Adjustment Form Variables * * * */
  currentGenerateBillingLineItemId: string = '';
  adjustmentDataEntryLocked: string = 'true';
  addedAdjustments: AddedAdjustments[] = [];
  disableAdjustmentSubmitButtonFlag: boolean = true;
  completedAdjustmentsGB: AdjustmentsCompletedGB[] = [];
  completedAdjustmentsMI: AdjustmentsCompletedMI[] = [];
  adjustedNetRevenue: number;
  adjustmentBeingAdded: boolean = false;
  adjustmentValidationMessages: AdjustmentValidation = new AdjustmentValidation();
  maximumAdjustmentNetAmount: number;
  maximumAdjustmentGrossAmount: number;
  isReturningFromAdjustmentsFlag: boolean = false;

  settingsStateValues: ISettingsState; // Boolean flag - if true, can override reference number format and negative payment allowed.

  //Services
  _messageDialogService = inject(MessageDialogService);
  _dataService = inject(DataService);
  _appGeneralState = inject(AppGeneralStateService);
  _sandboxService = inject(SandboxService);
  _destroyRefService = inject(DestroyRef);
  _issueNotificationService = inject(IssueDataService);

  constructor(
    private viewportScroller: ViewportScroller,
    public invoiceService: InvoiceService,
    public lotService: LotService,
    public router: Router,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private authService: AuthService,
    private adjustmentService: AdjustmentService,
    private quicksearchService: QuicksearchService,
    private messageService: MessageService,
    private apnUtilityService: ApnUtilitiesService,
    private _appGeneralStateService: AppGeneralStateService,
  ) {
    this.urlDomain = environment.UrlDomain;
    this._appGeneralStateService.lotNumberSubject.subscribe({
      next: (v) => this.onResetQuickSearchQueryResults(),
    });

    this.getAdminSettingsValues();
  }

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.refNumberErrorCount = 0;
  }

  onResetQuickSearchQueryResults(): void {
    this.quickSearchResults = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    let change = changes['quickSearchCriteria'];
    this.revenueTypes = [];
    this.paymentTypes = [];
    this.appliedRevenue = [];

    if (!change.firstChange) {
      try {
        this.rowsReturned = -1;
        this.quickSearchResults = [];
        this.getInvoiceToArray(this.quickSearchCriteria);
        this.getRevenueTypesForLotNumber(this.quickSearchCriteria.lotNumber);
        this.setLotSpecificData();
      } catch (err) {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::ngOnChanges().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      }
    } else {
      this.getCachedQuicksearchResults();
      this.getCachedAppliedPayments();
      this.getCachedGridView();
      this.paymentTypes = this.adjustmentService.getCurrentLotPaymentTypes();

      if (this.quickSearchResults !== undefined) {
        this.rowsReturned = this.quickSearchResults.length;
      }
    }
  }

  ngAfterViewInit(): void {
    this.setCurrentGridView();
  }

  initDataStructures() {
    this.pendingPayments = [];
    this.appliedPayments = [];
    this.quickSearchResults = [];
    this.paymentTypes = [];
    this.rowsReturned = -1;
    this.markForPayment = -1;
    this.paymentQueued = false;
    this.referenceNumber = '';
    this.gridMode = false;
    this.referenceNumberPlaceholder = '';
    this.showRevenuePostAdjustment = false;
    this.matchingTaxListForInvoice = [];
  }

  setLotSpecificData(): void {
    this.adjustmentService.initAdjustmentService();
    this.adjustmentService.setPaymentTypesForLot(this.quickSearchCriteria.lotNumber);
    this.adjustmentService.setInvoiceAdjustmentReasonsForLotNumber(this.quickSearchCriteria.lotNumber);
  }

  getInvoiceToArray(quickSearchCriteria: QuickSearchCriteria) {
    this.rowsReturned = -1;
    this.revenueTypes = [];

    this.quickSearchInit();

    this.getPaymentTypesForLotNumber(quickSearchCriteria.lotNumber);

    this.getRevenueAdjustmentReasonsList(this.quickSearchCriteria.lotNumber);

    this.initDataStructures();

    //If the user has added invoice number data, then search all invoices including zero balances
    if (this.quickSearchCriteria.invoiceNumber != '') this.quickSearchCriteria.zeroBalance = 1;

    switch (quickSearchCriteria.zeroBalance) {
      case 0: {
        this.getNonZeroBalanceInvoiceList(quickSearchCriteria);
        break;
      }
      case 1: {
        this.getZeroBalanceInvoiceList(quickSearchCriteria);
        break;
      }
      case 2: {
        this.getOnlyZeroBalanceInvoiceList(quickSearchCriteria);
        break;
      }
      case 3: {
        this.getCreditBalanceInvoiceList(quickSearchCriteria);
        break;
      }
      case 4: {
        this.getPastDueBalanceInvoiceList(quickSearchCriteria);
        break;
      }
    }

    this.gridMode = true;

    this.getActiveTaxListForLotNumber(quickSearchCriteria.lotNumber);
  }

  onIncreaseFontSize(): void {
    this.gridFontSize += 1;
  }

  onDecreaseFontSize(): void {
    this.gridFontSize -= 1;
  }

  cacheGridView(): void {
    this.quicksearchService.setCurrentQSRGridView(this.gridViewSelection);
  }

  getCachedGridView(): void {
    let currentQSRGridView: string;

    try {
      this.gridViewSelection = this.quicksearchService.getCurrentQSRGridView();
    } catch (err) {
      this.gridViewSelection = 0;

      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = 'Err: qs-results-grid.ts::getCachedGridView().';
      errorLogEntry.errorMessage = JSON.stringify(err);
      this.apnUtilityService.logErrorToDB(errorLogEntry);
    }
  }

  setCurrentGridView(): void {}

  cacheAppliedPayments(): void {
    this.quicksearchService.setAppliedPayments(this.appliedPayments);
  }

  getCachedAppliedPayments(): void {
    this.appliedPayments = this.quicksearchService.getAppliedPayments();
  }

  cacheQuicksearchResults(): void {
    this.quicksearchService.setQuickSearchResults(this.quickSearchResults);
  }

  getCachedQuicksearchResults(): void {
    this.quickSearchResults = this.quicksearchService.getQuickSearchResults();
  }

  getPastDueBalanceInvoiceList(quickSearchCriteria: QuickSearchCriteria) {
    this.invoiceService.getQuickSearchPastDueBalanceInvoiceList(quickSearchCriteria).subscribe(
      (quickSearchResults) => {
        this.quickSearchResults = quickSearchResults;
      },
      (err: any) => {
        this.rowsReturned = 0;
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getOnlyZeroBalanceInvoiceList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
        this._snackBar.open(
          'An unexpected error occurred while searching for invoices.  Please try again and if this continues to occur contact APN support.',
          '',
          { duration: 7000 },
        );
      },
      () => {
        if (this.quickSearchResults === null || this.quickSearchResults.length === 0) {
          this.rowsReturned = 0;
          this._snackBar.open('No invoices found matching this Lot Number and Search Criteria.', '', {
            duration: 5000,
          });
        } else this.cacheQuicksearchResults();

        this.onScrollToTop();

        this.rowsReturned = this.quickSearchResults.length;

        this.setStaticBalance();

        //this.sortedQuickSearchResults = this.quickSearchResults;

        //Init sort order for queue type to zero.
        //Initial value is 4 to sort at bottom on ascending sorts
        //Other values =
        //Payment Queued = 1
        //Payment submitted = 2
        //Payment Error = 3
        let ii: number = 0;
        if (this.quickSearchResults !== null) {
          for (ii = 0; ii < this.quickSearchResults.length; ii++) {
            this.quickSearchResults[ii].queueType = 4;
          }
        }
      },
    );
  }

  getCreditBalanceInvoiceList(quickSearchCriteria: QuickSearchCriteria) {
    this.invoiceService.getQuickSearchOnlyCreditBalanceInvoiceList(quickSearchCriteria).subscribe(
      (quickSearchResults) => {
        this.quickSearchResults = quickSearchResults;
      },
      (err: any) => {
        this.rowsReturned = 0;
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getOnlyZeroBalanceInvoiceList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
        this._snackBar.open(
          'An unexpected error occurred while searching for invoices.  Please try again and if this continues to occur contact APN support.',
          '',
          { duration: 7000 },
        );
      },
      () => {
        if (this.quickSearchResults === null || this.quickSearchResults.length === 0) {
          this.rowsReturned = 0;
          this._snackBar.open('No invoices found matching this Lot Number and Search Criteria.', '', {
            duration: 5000,
          });
        } else this.cacheQuicksearchResults();

        this.onScrollToTop();

        this.rowsReturned = this.quickSearchResults.length;

        this.setStaticBalance();

        //this.sortedQuickSearchResults = this.quickSearchResults;

        //Init sort order for queue type to zero.
        //Initial value is 4 to sort at bottom on ascending sorts
        //Other values =
        //Payment Queued = 1
        //Payment submitted = 2
        //Payment Error = 3
        let ii: number = 0;
        if (this.quickSearchResults !== null) {
          for (ii = 0; ii < this.quickSearchResults.length; ii++) {
            this.quickSearchResults[ii].queueType = 4;
          }
        }
      },
    );
  }

  getOnlyZeroBalanceInvoiceList(quickSearchCriteria: QuickSearchCriteria) {
    this.invoiceService.getQuickSearchOnlyZeroBalanceInvoiceList(quickSearchCriteria).subscribe(
      (quickSearchResults) => {
        this.quickSearchResults = quickSearchResults;
      },
      (err: any) => {
        this.rowsReturned = 0;
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getOnlyZeroBalanceInvoiceList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
        this._snackBar.open(
          'An unexpected error occurred while searching for invoices.  Please try again and if this continues to occur contact APN support.',
          '',
          { duration: 7000 },
        );
      },
      () => {
        if (this.quickSearchResults === null || this.quickSearchResults.length === 0) {
          this.rowsReturned = 0;
          this._snackBar.open('No invoices found matching this Lot Number and Search Criteria.', '', {
            duration: 5000,
          });
        } else this.cacheQuicksearchResults();

        this.onScrollToTop();

        this.rowsReturned = this.quickSearchResults.length;

        this.setStaticBalance();

        //this.sortedQuickSearchResults = this.quickSearchResults;

        //Init sort order for queue type to zero.
        //Initial value is 4 to sort at bottom on ascending sorts
        //Other values =
        //Payment Queued = 1
        //Payment submitted = 2
        //Payment Error = 3
        let ii: number = 0;
        if (this.quickSearchResults !== null) {
          for (ii = 0; ii < this.quickSearchResults.length; ii++) {
            this.quickSearchResults[ii].queueType = 4;
          }
        }
      },
    );
  }

  getNonZeroBalanceInvoiceList(quickSearchCriteria: QuickSearchCriteria) {
    this.invoiceService.getQuickSearchNonZeroBalanceInvoiceList(quickSearchCriteria).subscribe(
      (quickSearchResults) => {
        this.quickSearchResults = quickSearchResults;
      },
      (err: any) => {
        this.rowsReturned = 0;
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getNonZeroBalanceInvoiceList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
        this.messageService.addExceptionMessage('Something happened');
        this._snackBar.open(
          'An unexpected error occurred while searching for invoices.  Please try again and if this continues to occur contact APN support.',
          '',
          { duration: 7000 },
        );
      },
      () => {
        if (this.quickSearchResults === null || this.quickSearchResults.length === 0) {
          this.rowsReturned = 0;

          this._snackBar.open('No invoices found matching this Lot Number and Search Criteria.', '', {
            duration: 5000,
          });
        } else this.cacheQuicksearchResults();

        this.onScrollToTop();

        this.rowsReturned = this.quickSearchResults.length;

        this.setStaticBalance();

        //this.sortedQuickSearchResults = this.quickSearchResults;

        //Init sort order for queue type to zero.
        //Initial value is 4 to sort at bottom on ascending sorts
        //Other values =
        //Payment Queued = 1
        //Payment submitted = 2
        //Payment Error = 3
        let ii: number = 0;
        if (this.quickSearchResults !== null) {
          for (ii = 0; ii < this.quickSearchResults.length; ii++) {
            this.quickSearchResults[ii].queueType = 4;
          }
        }
      },
    );
  }

  onToggleShowGridColumns(): void {
    let gridTypeSelected: any;

    var e = document.getElementById('selectQSRLayout') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    gridTypeSelected = (<HTMLOptionElement>opt).value;

    this.gridViewSelection = +gridTypeSelected;
  }

  setStaticBalance() {
    let ii: number = 0;
    if (this.quickSearchResults !== null) {
      for (ii = 0; ii < this.quickSearchResults.length; ii++) {
        this.quickSearchResults[ii].originalBalance = this.quickSearchResults[ii].currentBalance;
      }
    }
  }

  getZeroBalanceInvoiceList(quickSearchCriteria: QuickSearchCriteria) {
    this.invoiceService.getQuickSearchZeroBalanceInvoiceList(quickSearchCriteria).subscribe(
      (quickSearchResults) => {
        this.quickSearchResults = quickSearchResults;
      },
      (err: any) => {
        this.rowsReturned = 0;
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getZeroBalanceInvoiceList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
        this._snackBar.open(
          'An unexpected error occurred while searching for invoices.  Please try again and if this continues to occur contact APN support.',
          '',
          { duration: 7000 },
        );
      },
      () => {
        if (this.quickSearchResults === null || this.quickSearchResults.length === 0) {
          this.rowsReturned = 0;
          this._snackBar.open('No invoices found matching this Lot Number and Search Criteria.', '', {
            duration: 3000,
          });
        } else {
          this.rowsReturned = this.quickSearchResults.length;
          this.quickSearchResults = this.quickSearchResults;

          this.cacheQuicksearchResults();

          this.setStaticBalance();
        }
      },
    );
  }

  getRevenueAdjustmentReasonsList(lotNumber: string) {
    this.invoiceService.getRevenueAdjustmentsReasonsForLotNumber(lotNumber).subscribe(
      (x) => {
        this.invoiceAdjustmentReasons = x;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getRevenueAdjustmentReasonsList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        let i: number = 0;
      },
    );
  }

  clearAllRowsFromActive(): void {
    this.currentlyActivePaymentRow = -1;
  }

  setQSRRowBackgroundColor(rowNumber: number): void {
    this.currentlyActivePaymentRow = rowNumber;
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActivePaymentRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }

  getPaymentTypesForLotNumber(lotNumber: string) {
    this.invoiceService
      .getPaymentTypesForLotNumber(lotNumber, 'qx-results-grid.getPaymentTypesForLotNumber()')
      .subscribe(
        (paymentTypeList) => {
          this.paymentTypes = paymentTypeList;
        },
        (err: any) => {
          let errorLogEntry: dbErrorEntry = new dbErrorEntry();

          errorLogEntry.Location = 'Err: qs-results-grid.ts::getPaymentTypesForLotNumber().';
          errorLogEntry.errorMessage = JSON.stringify(err);
          this.apnUtilityService.logErrorToDB(errorLogEntry);
        },
        () => {
          let aPaymentType: PaymentTypes = new PaymentTypes();
          aPaymentType.paymentCode = '0';
          aPaymentType.paymentDescription = this.PAYMENT_TYPE_OPTION_HEADER;
          this.paymentTypes.splice(0, 0, aPaymentType);
        },
      );
  }

  quickSearchInit(): void {
    this.areBatchPaymentsProcessing = false;
  }

  onQuickSearchResultsTabChanged(tabIndex: number): void {
    this.isSendInvoicesTabSelected = tabIndex === this.sendInvoicesTabIndex;

    if (this.isSendInvoicesTabSelected) {
      this.startSendInvoicesTabSpinner();
    }
  }

  onQuickSearchResultsTabIndexChanged(tabIndex: number): void {
    if (tabIndex === this.sendInvoicesTabIndex) {
      this.startSendInvoicesTabSpinner();
    }
  }

  onSendInvoicesTabInteractionStart(): void {
    this.startSendInvoicesTabSpinner();
  }

  onSendInvoicesTabLabelClicked(): void {
    this.onSendInvoicesTabInteractionStart();
  }

  onSendInvoicesLoadingStateChanged(isLoading: boolean): void {
    this.isSendInvoicesChildLoading = isLoading;

    if (isLoading && !this.sendInvoicesSpinnerStartTimestamp) {
      this.sendInvoicesSpinnerStartTimestamp = Date.now();
    }

    this.isSendInvoicesTabLoading = isLoading || !this.hasSendInvoicesFormRendered;
  }

  onSendInvoicesFormDisplayed(): void {
    this.hasSendInvoicesFormRendered = true;

    const elapsedMs = this.sendInvoicesSpinnerStartTimestamp
      ? Date.now() - this.sendInvoicesSpinnerStartTimestamp
      : this.sendInvoicesMinSpinnerMs;

    const remainingMs = Math.max(0, this.sendInvoicesMinSpinnerMs - elapsedMs);

    setTimeout(() => {
      this.isSendInvoicesTabLoading = false;
      this.sendInvoicesSpinnerStartTimestamp = 0;
    }, remainingMs);
  }

  private startSendInvoicesTabSpinner(): void {
    this.sendInvoicesSpinnerStartTimestamp = Date.now();
    this.isSendInvoicesTabLoading = true;
  }

  onSubmitPayments() {
    let i: number = 0;
    let paymentAmountToValidate: number = 0;
    let pendingNewInvoiceBalance: number = 0;
    let negativeBalanceInvoiceList: string = '';
    let negativeBalanceInvoicesCreated: boolean = false;
    let negativeInvoiceList: InvoiceNegativeBalance[] = [];

    for (i = 0; i < this.pendingPayments.length; i++) {
      paymentAmountToValidate = this.pendingPayments[i].paymentAmount;
      pendingNewInvoiceBalance = this.getPendingNewInvoiceBalance(
        paymentAmountToValidate,
        this.pendingPayments[i].invoiceNumber,
      );

      if (pendingNewInvoiceBalance < 0) {
        negativeBalanceInvoicesCreated = true;

        if (negativeBalanceInvoiceList !== '') negativeBalanceInvoiceList += ', ';

        negativeBalanceInvoiceList += this.pendingPayments[i].invoiceNumber;

        negativeInvoiceList.push({
          invoiceNumber: this.pendingPayments[i].invoiceNumber,
          paymentAmount: paymentAmountToValidate,
          newBalance: pendingNewInvoiceBalance,
          totalPaymentNumber: this.pendingPayments.length,
        });
      }
    }

    //If any pending negative balance invoices then display dialog
    if (negativeBalanceInvoicesCreated === true) {
      const dialogRef = this.dialog.open(ConfirmSubmitPaymentComponent, {
        data: {
          invoiceList: negativeInvoiceList,
        },
        width: '900px',
        height: '270px',
        position: { top: '75px' },
      });

      //return when dialog closed and process if proceed or cancel
      dialogRef.afterClosed().subscribe((result) => {
        if (result == true) this.applyInvoicePayments(); //the user responded yes to the potential negative invoice dialog and so process payments
      });
    } else this.applyInvoicePayments(); // no negative balance invoice payments were found so process the payments.
  }

  onCloseBatchPaymentInvoiceError(): void {
    this.batchInvoiceErrorMessage = '';
  }

  sortInvoiceData(sort: Sort) {
    let tempSort: QuickSearchResults[] = [];

    const data = this.quickSearchResults.slice();
    if (!sort.active || sort.direction === '') {
      tempSort = data;
      return;
    }

    tempSort = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';

      switch (sort.active) {
        case 'queued':
          return this.compare(a.queueType, b.queueType, isAsc);
        case 'invoiceDate':
          return this.compare(a.invoiceDate, b.invoiceDate, isAsc);
        case 'invoiceNumber':
          return this.compare(a.invoiceNumber, b.invoiceNumber, isAsc);
        case 'rate':
          return this.compare(a.rate, b.rate, isAsc);
        case 'cardNo':
          return this.compare(a.cardNo, b.cardNo, isAsc);
        case 'customerName':
          return this.compare(a.customerName, b.customerName, isAsc);
        case 'companyName':
          return this.compare(a.companyName, b.companyName, isAsc);
        case 'created':
          return this.compare(a.created, b.created, isAsc);
        case 'dueDate':
          return this.compare(a.dueDate, b.dueDate, isAsc);
        case 'delivery':
          return this.compare(a.delivery, b.delivery, isAsc);
        case 'dateSent':
          return this.compare(a.dateSent, b.dateSent, isAsc);
        case 'paymentType':
          return this.compare(a.paymentType, b.paymentType, isAsc);
        case 'paymentAmount':
          return this.compare(a.paymentAmount, b.paymentAmount, isAsc);
        case 'referenceNumber':
          return this.compare(a.referenceNumber, b.referenceNumber, isAsc);
        case 'adjustmentAmount':
          return this.compare(a.adjustmentAmount, b.adjustmentAmount, isAsc);
        case 'transactionDate':
          return this.compare(a.transactionDate, b.transactionDate, isAsc);
        case 'datePaid':
          return this.compare(a.datePaid, b.datePaid, isAsc);
        case 'currentBalance':
          return this.compare(a.currentBalance, b.currentBalance, isAsc);
        default:
          return 0;
      }
    });

    this.quickSearchResults = tempSort;
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    // nulls sort after anything else

    if (isAsc) {
      if (a === null) {
        return 1;
      }

      if (a === '') {
        return 1;
      }

      if (b === null) {
        return -1;
      }

      if (b === '') {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? -1 : 1;
    } else {
      if (a === null) {
        return 1;
      }

      if (a === '') {
        return 1;
      }

      if (b === null) {
        return -1;
      }

      if (b === '') {
        return -1;
      }

      if (a === b) {
        return 0;
      }

      return a < b ? 1 : -1;
    }
  }

  onMouseOverQuickSearchGrid(rowIndex: number): void {
    this.rowSelectedOnGrid = rowIndex;
  }

  onMouseLeaveQuickSearchGrid(rowIndex: number): void {
    this.rowSelectedOnGrid = -1;
  }

  removePendingPaymentRecordFromGrid(rowIndex: number, invoiceNumber: string): boolean {
    let pendingPaymentsRowIndex: number = -1;
    let ii: number = 0;

    try {
      //this.quickSearchResults[rowIndex].markedForDeletion = true;

      //find the array member in the pending payments list
      for (ii = 0; ii < this.pendingPayments.length; ii++) {
        if (this.pendingPayments[ii].invoiceNumber === invoiceNumber) pendingPaymentsRowIndex = ii;
      }

      //If this pending payment exists, then delete it and reset back to no payment pending in quicksearch results list
      if (pendingPaymentsRowIndex > -1) {
        this.pendingPayments.splice(pendingPaymentsRowIndex, 1);
        this.quickSearchResults[rowIndex].queueType = 0; //resets queue to no payment queued or paid
        this.quickSearchResults[rowIndex].paymentQueued = false;
        this.quickSearchResults[rowIndex].markedForPayment = false;
        this.quickSearchResults[rowIndex].invalidPayment = false;
        this.quickSearchResults[rowIndex].invalidReferenceNumber = false;
        this.quickSearchResults[rowIndex].currentBalance = this.quickSearchResults[rowIndex].originalBalance;
        this.quickSearchResults[rowIndex].queueType = 0;
        this.referenceNumberErrorMessage = '';

        //reset the payment type to no payment type
        var e = document.getElementById('selectPaymentType' + rowIndex) as HTMLSelectElement;
        var sel = e.selectedIndex;
        var opt = e.options[sel];
        e.selectedIndex = 0;
        (<HTMLOptionElement>opt).value = '0';
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  isPaymentPendingOnGrid(rowIndex: number): boolean {
    let paymentIsPending: boolean = false;
    let ii: number = 0;

    if (this.quickSearchResults[rowIndex].paymentQueued && this.quickSearchResults[rowIndex]?.paymentApplied !== true) {
      return true;
    }

    return paymentIsPending;
  }

  isPaymentPaidOnGrid(rowIndex: number): boolean {
    let paymentIsPaid: boolean = false;

    paymentIsPaid = this.quickSearchResults[rowIndex].paymentApplied === true;

    return paymentIsPaid;
  }

  isPaymentError(rowIndex: number): boolean {
    let isPaymentError: boolean = false;

    isPaymentError = this.quickSearchResults[rowIndex].queueType === 3;

    return isPaymentError;
  }

  onShowGridReload(rowIndex: number): boolean {
    let showReloadButton: boolean = true;

    if (this.rowSelectedOnGrid === rowIndex) {
      if (rowIndex != this.rowSelectedOnGrid) showReloadButton = false;

      if (this.quickSearchResults[rowIndex].paymentApplied) showReloadButton = false;

      if (
        this.quickSearchResults[rowIndex].paymentQueued &&
        this.quickSearchResults[rowIndex]?.paymentApplied !== true
      ) {
        showReloadButton = false;
      }

      return showReloadButton;
    }
    return false;
  }

  onPaymentChange(currentIndex: number, theEvent: any) {
    this.currentlyActivePaymentRow = currentIndex;

    if (false === this.isMaximumQueuedPayments()) {
      this.quickSearchResults[currentIndex].markedForPayment = true;

      var paymentTypeText: string = this.getPaymentTypeText(currentIndex);

      if (paymentTypeText.toUpperCase() === this.PAYMENT_TYPE_OPTION_HEADER) {
        this.referenceNumberPlaceholder = '';
        this.quickSearchResults[currentIndex].markedForPayment = false;
        let invoiceNumber = this.quickSearchResults[currentIndex].invoiceNumber;
        this.quickSearchResults[currentIndex].paymentQueued = false;
        this.quickSearchResults[currentIndex].invalidPayment = false;
        this.removePendingPaymentRecord(invoiceNumber);
        this.referenceNumberErrorMessage = '';
      }

      if (paymentTypeText.toUpperCase() === 'AMEX') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'CHECK') {
        this.referenceNumberPlaceholder = '########-####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'REFUND PAYMENT') {
        this.referenceNumberPlaceholder = '########';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'DISCOVER') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'DINERS CLUB') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'VISA MC') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'VISA/MC') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'AMEXP') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'CC-OTHER') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'OPTIMA') {
        this.referenceNumberPlaceholder = '####';
        return;
      }

      if (paymentTypeText.toUpperCase() === 'CASH') {
        this.referenceNumberPlaceholder = '########';
        return;
      }

      this.referenceNumberPlaceholder = '########';
    } else {
      //we have reached maximum pending payments and cannot configure another one.
      (<HTMLOptionElement>document.getElementById('selectPaymentType' + currentIndex)).value = '0';

      let maxQueuedPayments: number = this.invoiceService.GetMaximumNumberOfConcurrentPayments();
      this._snackBar.open(
        'The maximum number of queued payments (' +
          maxQueuedPayments.toString() +
          ') has been reached.  Please submit these payments or remove one before you may add another payment.',
        '',
        { duration: 5000 },
      );
    }
  }

  isMarkedForPayment(invoiceNumber: string): boolean {
    let invoiceIsMarkedForPayment: boolean = false;

    let currentIndex: number = -1;

    let ii: number = 0;

    for (ii = 0; ii < this.quickSearchResults.length; ii++) {
      if (this.quickSearchResults[ii].invoiceNumber === invoiceNumber) {
        currentIndex = ii;
      }
    }

    invoiceIsMarkedForPayment = this.quickSearchResults[currentIndex].markedForPayment;

    return invoiceIsMarkedForPayment;
  }

  onAddPendingPayment(currentIndex: number, lotNumber: string, invoiceNumber: string) {
    var paymentAmount: number = this.getPaymentAmount(currentIndex);
    var referenceNumber: string = this.getReferenceNumber(currentIndex);
    var paymentCode: string = this.getPaymentCode(currentIndex);
    var paymentTypeText: string = this.getPaymentTypeText(currentIndex);

    this.clearAllRowsFromActive(); //clears row background flag

    if (paymentAmount >= 1000000) {
      this._messageDialogService.snackBarTopCenterTimed('The payment amount cannot exceed $999,999.99.', 5000);
      return;
    }

    if (false === this.arePaymentDetailsValid(currentIndex)) {
      this.removePendingPaymentRecord(invoiceNumber);
      this.quickSearchResults[currentIndex].paymentQueued = false;

      return;
    }

    //Temporary check for invalid Payment Code and to log data in DB
    //Currently this only logs the error but doesn't interfere with the processing flow
    if (
      false ===
      this.isPaymentCodeValid(
        paymentCode,
        'Lanai - Angular Client QSR Grid :: onAddPendingPayment()',
        invoiceNumber,
        paymentTypeText,
        paymentAmount,
      )
    ) {
    }

    this.adjustInvoiceBalance(currentIndex, paymentAmount);

    //add new payment
    this.pendingPayments.push({
      lotNumber: lotNumber,
      invoiceNumber: invoiceNumber,
      paymentType: paymentTypeText,
      referenceNumber: referenceNumber,
      paymentAmount: paymentAmount,
      paymentCode: paymentCode,
      gridIndexNumber: currentIndex,
    });

    let elementIndex: number = this.getArrayIndexOfInvoiceNumberInQuickSearchResults(invoiceNumber);

    if (elementIndex !== -1) {
      this.quickSearchResults[elementIndex].queueType = 1;
    }

    this.markForPayment = 1;
    this.paymentQueued = true;
    this.quickSearchResults[currentIndex].queueType = 1;
    this.quickSearchResults[currentIndex].markedForPayment = true;
    this.quickSearchResults[currentIndex].paymentQueued = true;
    this.refNumberErrorCount = 0;
  }

  isPaymentCodeValid(
    paymentCode: string,
    functionLocation: string,
    invoiceNumber: string,
    paymentDescription: string,
    paymentAmount: number,
  ): boolean {
    let isValid: boolean = true;
    let errorMessage: string = '';

    if (paymentCode.length < 3) {
      isValid = false;
    }

    if (paymentCode.length === 11) {
      isValid = false;
    }

    if (false === isValid) {
      errorMessage = 'NG Error :: Invalid PaymentCode Detected @ function: ' + functionLocation + '.';
      errorMessage += ' Payment Code: ' + paymentCode + ' | ';
      errorMessage += ' InvoiceNumber: ' + invoiceNumber + ' | ';
      errorMessage += ' Payment Type: ' + paymentDescription + ' | ';
      errorMessage += ' Payment Amount: ' + paymentAmount + ' | ';
      errorMessage += ' User Name: ' + this._appGeneralStateService.userName + ' | ';

      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = functionLocation;
      errorLogEntry.errorMessage = errorMessage;

      this.apnUtilityService.logErrorToDB(errorLogEntry);

      //this.messageService.addExceptionMessage('An error occurred while queueing this payment. Please review the payment data and resubmit to the pending payment queue. Also try to search for this invoice again and then submitting the payment, or submitting via the enable screen.  If the error continues to occur, please contact APN Support.');
    }

    return isValid;
  }

  launchEnableModeForInvoice(invoiceNumber: string, rowId: number) {
    this.cacheQuicksearchResults();

    this.cacheAppliedPayments();

    this.cacheGridView();

    this.router.navigate(['/adjustmentsHome', invoiceNumber]);
  }

  getPendingNewInvoiceBalance(pendingInvoicePayment: number, invoiceNumber: string): number {
    let i: number = 0;
    let newInvoiceBalance: number = 0;
    let existingInvoiceBalance: number = 0;

    try {
      for (i = 0; i < this.quickSearchResults.length; i++) {
        if (this.quickSearchResults[i].invoiceNumber === invoiceNumber) {
          existingInvoiceBalance = this.quickSearchResults[i].originalBalance;
        }
      }

      newInvoiceBalance = existingInvoiceBalance - pendingInvoicePayment;
    } catch (error) {
      return 0;
    }

    return newInvoiceBalance;
  }

  applyInvoicePayments() {
    let newPaymentData: InvoicePayment[] = [];
    let ii: number = 0;

    for (ii = 0; ii < this.pendingPayments.length; ii++) {
      //Check to determine where PaymentCode is not being submitted accurately.
      //This will check the payment code and log an error but doesn't alter the processing flow

      this.isPaymentCodeValid(
        this.pendingPayments[ii].paymentCode, //this.pendingPayments[ii].paymentCode,
        'Lanai - Angular Client QSR Grid:: applyInvoicePayments()',
        this.pendingPayments[ii].invoiceNumber,
        this.pendingPayments[ii].paymentType,
        this.pendingPayments[ii].paymentAmount,
      );

      let newPaymentDetails: InvoicePayment = new InvoicePayment();

      newPaymentDetails.Comments = '';
      newPaymentDetails.FilterDescription = this.pendingPayments[ii].paymentType;
      newPaymentDetails.HideOnInvoice = false;
      newPaymentDetails.InvoiceNumber = this.pendingPayments[ii].invoiceNumber;
      newPaymentDetails.IsLocked = true;
      newPaymentDetails.IsMidnight = false;
      newPaymentDetails.IsRSUpdated = false;
      newPaymentDetails.IsTrainingData = false;
      newPaymentDetails.LotNumber = this.pendingPayments[ii].lotNumber;
      newPaymentDetails.PaymentAmount = this.pendingPayments[ii].paymentAmount;
      newPaymentDetails.PaymentCode = this.pendingPayments[ii].paymentCode;
      newPaymentDetails.PaymentMode = true;
      newPaymentDetails.Username = this._appGeneralStateService.userName;
      newPaymentDetails.ReferenceNumber = this.pendingPayments[ii].referenceNumber;
      newPaymentDetails.PaymentType = this.pendingPayments[ii].paymentType;
      newPaymentDetails.PaymentStatus = 0;
      newPaymentDetails.PaymentTransactionType = 1;

      newPaymentData.push(newPaymentDetails);
    }

    this.postInvoicePayment_ex(newPaymentData);

    //No matter the results of the payment processing, we dump all the pending payments from the queue
    this.pendingPayments.length = 0;
  }

  isMaximumQueuedPayments(): boolean {
    let isMaxQueued: boolean = false;
    let numberOfQueuedPayments: number;

    numberOfQueuedPayments = this.pendingPayments.length;

    isMaxQueued = numberOfQueuedPayments >= this.invoiceService.GetMaximumNumberOfConcurrentPayments();

    return isMaxQueued;
  }

  getPaymentTypeText(rowIndex: number): string {
    let paymentTypeText: string;

    var e = document.getElementById('selectPaymentType' + rowIndex) as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    paymentTypeText = (<HTMLOptionElement>opt).text;

    return paymentTypeText;
  }

  removePendingPaymentRecord(invoiceNumber: string): boolean {
    let rowNumberExists: number = -1;
    let ii: number = 0;

    try {
      for (ii = 0; ii < this.pendingPayments.length; ii++) {
        if (this.pendingPayments[ii].invoiceNumber === invoiceNumber) rowNumberExists = ii;
      }

      if (rowNumberExists > -1) {
        this.quickSearchResults[ii].paymentQueued = false;
        this.pendingPayments.splice(rowNumberExists, 1);
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  getPaymentAmount(rowIndex: number): number {
    let paymentAmount: number = 0;
    let paymentAsString: string = (<HTMLInputElement>document.getElementById('txtPaymentAmount' + rowIndex)).value;

    if (paymentAsString != null) {
      paymentAmount = this.parseFloatIgnoreCommas(paymentAsString);
    }

    return paymentAmount;
  }

  getReferenceNumber(rowIndex: number): string {
    let referenceNumber: string = (<HTMLInputElement>document.getElementById('txtReferenceNumber' + rowIndex)).value;

    return referenceNumber;
  }

  getPaymentCode(rowIndex: number): string {
    let paymentCode: string;

    var e = document.getElementById('selectPaymentType' + rowIndex) as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    paymentCode = (<HTMLOptionElement>opt).value;
    return paymentCode;
  }

  adjustInvoiceBalance(rowIndex: number, paymentAmount: number) {
    let currentBalance = this.quickSearchResults[rowIndex].originalBalance;
    this.quickSearchResults[rowIndex].currentBalance = currentBalance - paymentAmount;

    if (currentBalance - paymentAmount < 0) {
      this._snackBar.open('This payment will create a new invoice balance less than $0.00.', '', { duration: 3000 });
    }
  }

  arePaymentDetailsValid(currentIndex: number): boolean {
    let isValid: boolean = true;

    isValid = this.isInvoicePaymentValid(currentIndex);
    if (false == isValid) return isValid;

    isValid = this.isReferenceNumberValid(currentIndex);

    if (false == isValid) return isValid;

    return isValid;
  }

  pendingPaymentRecordExists(invoiceNumber: string): number {
    let rowNumberExists: number = -1;
    let ii: number = 0;

    for (ii = 0; ii < this.pendingPayments.length; ii++) {
      if (this.pendingPayments[ii].invoiceNumber === invoiceNumber) rowNumberExists = ii;
    }

    return rowNumberExists;
  }

  getArrayIndexOfInvoiceNumberInQuickSearchResults(invoiceNumber: string): number {
    let elementIndex: number = -1;

    let ii: number = 0;

    for (ii = 0; ii < this.quickSearchResults.length; ii++) {
      if (this.quickSearchResults[ii].invoiceNumber === invoiceNumber) {
        return ii;
      }
    }

    return elementIndex;
  }

  initEnableModeVariablesData(): void {
    this.adjustmentCurrentDate = this.getCurrentDate();
    this.taxableRevenueShouldBeApplied = true;
    this.baseTaxToCalcFrom = 0;
    this.totalTaxRate = 0;
    this.calcTaxAmount = 0;
    this.calcTotalAmount = 0;
    this.calcRate = 0;
    this.netTaxAmount = 0;
  }

  getCurrentDate(): any {
    var today = new Date();
    var returnDate = '';

    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    returnDate += `${mm}/${dd}/${yyyy}`;

    return returnDate;
  }

  isInvoiceGBType(invoiceNumber: string): boolean {
    let isGB: boolean;

    if (invoiceNumber.length === 0) isGB = false;

    if (invoiceNumber.substring(0, 2) === 'GB') isGB = true;
    else isGB = false;

    return isGB;
  }

  // setInvoiceDetailData(invoiceNumber: string): void{

  //   let ii: number = 0;
  //   let selectedInvoice: QuickSearchResults = new QuickSearchResults();

  //   for(ii = 0; ii < this.quickSearchResults.length; ii++){
  //     if(this.quickSearchResults[ii].invoiceNumber === invoiceNumber){
  //       selectedInvoice = this.quickSearchResults[ii];
  //     }
  //   }

  //   this.workingInvoiceNumber = selectedInvoice.invoiceNumber;
  //   this.workingInvoiceAmount = selectedInvoice.rate;
  //   this.workingInvoiceBalance = selectedInvoice.currentBalance;

  //   if(selectedInvoice.customerName !== '')
  //     this.workingCustomerName = selectedInvoice.customerName;
  //   else
  //     this.workingCustomerName = selectedInvoice.companyName;

  //   var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  //   var d = new Date(selectedInvoice.invoiceDate);
  //   var monthName=months[d.getMonth()];
  //   var year = d.getFullYear();

  //   this.workingInvoicePeriod = monthName + ', ' + year;

  // }

  getPaymentsForInvoiceNumber(invoiceNumber: string) {
    this.invoiceService.getPaymentListForInvoiceNumber(invoiceNumber).subscribe(
      (paymentTypeList) => {},
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getPaymentsForInvoiceNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  getRevenueTypesForLotNumber(lotNumber: string) {
    let tempRevenueTypes: RevenueTypes[];
    this.invoiceService.getRevenueTypesForLotNumber(lotNumber).subscribe(
      (revenueTypes) => {
        tempRevenueTypes = revenueTypes;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getRevenueTypesForLotNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        this.revenueTypes = tempRevenueTypes;
      },
    );
  }

  getInvoiceAdjustmentReasonsForLotNumber(lotNumber: string) {
    this.invoiceService.getAdjustmentReasonsForLotNumber(lotNumber).subscribe(
      (invoiceAdjustmentReasons) => {
        this.invoiceAdjustmentReasons = invoiceAdjustmentReasons;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getInvoiceAdjustmentReasonsForLotNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  resetGridPaymentsOnEnableMode() {
    let ii: number = 0;

    for (ii = 0; ii < this.quickSearchResults.length; ii++) {
      this.quickSearchResults[ii].markedForPayment = false;
    }
  }

  getInvoiceAdjustmentsForInvoiceNumber_GB(invoiceNumber: string) {
    this.invoiceService.getAdjustmentsForInvoiceNumber_GB(invoiceNumber).subscribe(
      (invoiceAdjustments) => {
        this.invoiceAdjustments = invoiceAdjustments;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getInvoiceAdjustmentsForInvoiceNumber_GB().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        //copy generateBillingLineItemID to primaryKey
        let ii: number = 0;
        for (ii = 0; ii < this.invoiceAdjustments.length; ii++) {
          this.invoiceAdjustments[ii].primaryKey = this.invoiceAdjustments[ii].generateBillingLineItemId;

          //Add any adjustmnets to invoiceAdjustments array
          if (this.invoiceAdjustments[ii].adjustment < 0) {
            this.addedAdjustments.push({
              description: this.invoiceAdjustments[ii].customerName,
              adjustmentAmount: this.invoiceAdjustments[ii].adjustment,
            });
          }
        }
      },
    );
  }

  getInvoiceAdjustmentsForInvoiceNumber_MI(invoiceNumber: string) {
    this.invoiceService.getAdjustmentsForInvoiceNumber_MI(invoiceNumber).subscribe(
      (invoiceAdjustments) => {
        this.invoiceAdjustments = invoiceAdjustments;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getInvoiceAdjustmentsForInvoiceNumber_MI().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        //copy billingDetailId to primaryKey, manualInvoiceId to generateBillingLineItemId
        let ii: number = 0;
        for (ii = 0; ii < this.invoiceAdjustments.length; ii++) {
          this.invoiceAdjustments[ii].primaryKey = this.invoiceAdjustments[ii].billingDetailID.toString();
          this.invoiceAdjustments[ii].generateBillingLineItemId = this.invoiceAdjustments[ii].manualInvoiceId;

          //Add any adjustmnets to invoiceAdjustments array
          if (this.invoiceAdjustments[ii].adjustment < 0) {
            this.addedAdjustments.push({
              description: this.invoiceAdjustments[ii].customerName,
              adjustmentAmount: this.invoiceAdjustments[ii].adjustment,
            });
          }
        }
      },
    );
  }

  getAdjustmentsCompletedForGB(invoiceNumber: string): void {
    this.invoiceService.getAdjustmentsCompleted_GB(invoiceNumber).subscribe(
      (adjustmentListResults) => {
        this.completedAdjustmentsGB = adjustmentListResults;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getAdjustmentsCompletedForGB().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  getAdjustmentsCompletedForMI(invoiceNumber: string): void {
    this.invoiceService.getAdjustmentsCompleted_MI(invoiceNumber).subscribe(
      (adjustmentListResults) => {
        this.completedAdjustmentsMI = adjustmentListResults;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getAdjustmentsCompletedForMI().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  getActiveTaxListForLotNumber(lotNumber: string) {
    this.lotService.getActiveTaxListByLotNumber(lotNumber).subscribe(
      (taxListForLot) => {
        this.activeTaxListForLot = taxListForLot;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getActiveTaxListForLotNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  getTaxListThatMatchInvoiceDate(invoiceNumber: string): void {
    this.invoiceService.getTaxListThatMatchInvoiceDate(invoiceNumber).subscribe(
      (x) => {
        this.matchingTaxListForInvoice = x;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getTaxListThatMatchInvoiceDate().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        let ii: number = 0;

        for (ii = 0; ii < this.matchingTaxListForInvoice.length; ii++) {
          let description: string = this.matchingTaxListForInvoice[ii].taxName;
          // remove old from tax type description
          description = description.replace(' - OLD', '');
          this.matchingTaxListForInvoice[ii].taxName = description;
        }
      },
    );
  }

  getRevenueAdjustmentList(invoiceNumber: string) {
    this.invoiceService.getRevenueAdjustmentsForInvoiceNumber(invoiceNumber).subscribe(
      (adjustmentList) => {
        this.appliedRevenue = adjustmentList;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getRevenueAdjustmentList().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        let ii: number = 0;
        for (ii = 0; ii < this.appliedRevenue.length; ii++) {
          this.appliedRevenue[ii].revenueTypeName = this.getRevenueTypeNameFromCode(
            this.appliedRevenue[ii].revenueType,
          );
        }
      },
    );
  }

  getRevenuePostAdjustmentsByInvoiceNumber(invoiceNumber: string, lotNumber: string): void {
    let queryCriteria: RevenuePostAdjustmentQuery = new RevenuePostAdjustmentQuery();
    queryCriteria.lotNumber = lotNumber;
    queryCriteria.invoiceNumber = invoiceNumber;

    this.invoiceService.getRevenuePostAdjustmentsCompletedByInvoiceNumber(queryCriteria).subscribe(
      (adjustmentListResults) => {
        this.revenuePostAdjustments = adjustmentListResults;
      },
      (err: any) => {
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::getRevenuePostAdjustmentsByInvoiceNumber().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {},
    );
  }

  calculateTotalTaxRate(): number {
    let i: number = 0;
    let totalTaxRate: number = 0;

    for (i = 0; i < this.activeTaxListForLot.length; i++) {
      totalTaxRate += this.activeTaxListForLot[i].taxAmount;
    }

    //set class level var
    this.totalTaxRate = totalTaxRate;

    return totalTaxRate;
  }

  initAdjustmentForm(): void {
    try {
      (<HTMLInputElement>document.getElementById('adjustmentAmountNet')).value = '';
      (<HTMLInputElement>document.getElementById('adjustmentAmountGross')).value = '';
      (<HTMLInputElement>document.getElementById('adjustmentComment')).value = '';
    } catch (err) {}
  }

  onResetAddNewAdjustmentData(): void {
    try {
      this.disableAdjustmentSubmitButtonFlag = true;

      if (this.invoiceAdjustments.length > 0)
        (<HTMLOptionElement>document.getElementById('adjustmentInvoiceLineItem')).value = '0';

      (<HTMLInputElement>document.getElementById('adjustmentInvoiceLineCurrentDate')).value = this.getCurrentDate();
      (<HTMLInputElement>document.getElementById('adjustmentAmountNet')).value = '';
      (<HTMLInputElement>document.getElementById('adjustmentAmountGross')).value = '';
      (<HTMLOptionElement>document.getElementById('adjustmentReasons')).value = '0';
      (<HTMLInputElement>document.getElementById('adjustmentComment')).value = '';

      this.adjustmentValidationMessages = new AdjustmentValidation();
    } catch (err) {}
  }

  onScrollToTop(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  getRevenueTypeNameFromCode(revenueTypeCode: string): string {
    let i: number = 0;
    let revenueTypeName: string = '';

    try {
      for (i = 0; this.revenueTypes.length; i++) {
        if (this.revenueTypes[i].code === revenueTypeCode) {
          revenueTypeName = this.revenueTypes[i].description;
          break;
        }
      }
    } catch (err) {
      revenueTypeName = '';
      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = 'Err: qs-results-grid.ts::getRevenueTypeNameFromCode().';
      errorLogEntry.errorMessage = JSON.stringify(err);
      this.apnUtilityService.logErrorToDB(errorLogEntry);
    }

    return revenueTypeName;
  }

  isInvoicePaymentValid(currentIndex: number): boolean {
    let isValid: boolean = true;

    let paymentAmount: number = this.getPaymentAmount(currentIndex);

    if (isNaN(Number(paymentAmount))) {
      isValid = false;
    }

    if (paymentAmount === 0) {
      isValid = false;
    }

    this.quickSearchResults[currentIndex].invalidPayment = !isValid;

    return isValid;
  }

  isFormat8Dash4ReferenceNumberValid(referenceNumber: string): boolean {
    let isValid: boolean = true; //assume true and return false if error condition

    //Check length must equal 13 charachters
    if (referenceNumber.length !== 13) {
      this.referenceNumberErrorMessage = '13 characters required(########-####)';
      return false;
    }

    //Check that the 9th charachter is a hyphen/dash/ "-"

    let dashChar: string = referenceNumber.substring(8, 9);
    if (dashChar !== '-' || dashChar !== '-') {
      this.referenceNumberErrorMessage = 'Dash is required(########-####)';
      return false;
    }

    return isValid;
  }

  isFormatRefundPaymentReferenceNumberValid(referenceNumber: string): boolean {
    let isValid: boolean = true; //assume true and return false if error condition

    //Check length must equal 13 charachters
    if (referenceNumber.length !== 8) {
      this.referenceNumberErrorMessage = '8 characters required(########)';
      return false;
    }
    return isValid;
  }

  onKeyPressedReferenceNumber(keyValue: any): void {
    const restrictedStringList = '`";:<>?/!@#$%^&*()_+=';
    const restrictedChars = [...restrictedStringList];
    var restrictedKeyFound: boolean = false;
    var ii: number;
    let restrictedKeyValue: string = '';

    for (ii = 0; ii < restrictedChars.length; ii++) {
      if (keyValue.key.includes(restrictedChars[ii])) {
        restrictedKeyValue = keyValue.key;
        restrictedKeyFound = true;
        break;
      }
    }

    if (restrictedKeyFound) {
      this._messageDialogService.snackBarTopCenterTimed(
        `A restricted key has been entered and is prohibited in the reference number.  Key: ${restrictedKeyValue}`,
        5000,
      );
    }
  }

  displayInvalidReferenceNumberDialog(dialogData: IRestrictedCharsError) {
    const dialogRef = this.dialog.open(DialogInvalidReferenceNumberComponent, {
      data: { checkedReferenceNumber: dialogData.checkedReferenceNumber, restrictedChars: dialogData.restrictedChars },
      minWidth: '600px',
      minHeight: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  formatReferenceNumberErrorMessage(referenceNumber: string): IRestrictedCharsError {
    const restrictedStringList = '`";:<>?/!@#$%^&*()_+=';
    const restrictedChars = [...restrictedStringList];
    var ii: number;
    var invalidCharsFound: string = '';
    var resturnData: IRestrictedCharsError = {} as IRestrictedCharsError;

    for (ii = 0; ii < restrictedChars.length; ii++) {
      if (referenceNumber.includes(restrictedChars[ii])) {
        invalidCharsFound += restrictedChars[ii];
      }
      referenceNumber = referenceNumber.replace(restrictedChars[ii], '');
    }

    resturnData.checkedReferenceNumber = referenceNumber;
    resturnData.restrictedChars = invalidCharsFound;

    return resturnData;
  }

  onDisplayInvoice(invoiceNumber: string, lotNumber: string, entityId: string): void {
    this._messageDialogService.snackBarTopCenterTimed(`Generating Invoice for ${invoiceNumber}...`, 2000);

    if (invoiceNumber.substring(0, 2) == 'MI') {
      const invoiceViewUrl = this.router.serializeUrl(
        this.router.createUrlTree(['/viewinvoice', entityId, lotNumber, invoiceNumber]),
      );
      const w = window.open(invoiceViewUrl, '_blank');

      if (!w) {
        console.error('Failed to open new window. Popup blocker might be active.');
      }
    } else {
      const safeEntityId = entityId && entityId.trim().length > 0 ? entityId : 'na';
      const invoiceViewUrl = this.router.serializeUrl(
        this.router.createUrlTree(['/viewinvoice', safeEntityId, lotNumber, invoiceNumber]),
      );
      const w = window.open(invoiceViewUrl, '_blank');

      if (!w) {
        console.error('Failed to open new window. Popup blocker might be active.');
      }
    }
  }

  isReferenceNumberValid(currentIndex: number): boolean {
    let paymentTypeText: string = this.getPaymentTypeText(currentIndex);
    let referenceNumber: string = this.getReferenceNumber(currentIndex);
    let referenceNumberErrMessage: IRestrictedCharsError = this.formatReferenceNumberErrorMessage(referenceNumber);

    this.quickSearchResults[currentIndex].invalidReferenceNumber = false;
    this.referenceNumberErrorMessage = ''; //reset

    if (referenceNumberErrMessage.restrictedChars.length > 0) {
      this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
      this.referenceNumberErrorMessage = 'Restricted characters entered';
      if (this.refNumberErrorCount == 0) {
        this.displayInvalidReferenceNumberDialog(referenceNumberErrMessage);
        this.refNumberErrorCount++;
      }
      return false;
    }

    if (this._appGeneralStateService.isPaymentRefundOverrideActive) {
      if (referenceNumber.length >= 1 && referenceNumber.length <= 32) return true;
      else {
        this.referenceNumberErrorMessage = '32 characters maximum';
        this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
        return false;
      }
    } else {
      if (paymentTypeText.toUpperCase() === 'AMEX') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'VISA/MC') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CHECK') {
        if (this.isFormat8Dash4ReferenceNumberValid(referenceNumber) === true) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'REFUND PAYMENT') {
        if (this.isFormatRefundPaymentReferenceNumberValid(referenceNumber) === true) return true;
        else {
          this.paymentValidationMessages.isInvalid = true;
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'DISCOVER') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'DINERS CLUB') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'VISA MC') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'VISA/MC') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'AMEXP') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CC-OTHER') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'OPTIMA') {
        if (referenceNumber.length === 4) return true;
        else {
          this.referenceNumberErrorMessage = '4 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      if (paymentTypeText.toUpperCase() === 'CASH') {
        if (referenceNumber.length === 8) return true;
        else {
          this.referenceNumberErrorMessage = '8 characters required';
          this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
          return false;
        }
      }

      //all other reference types must be 8 characters long
      if (referenceNumber.length === 8) return true;
      else {
        this.referenceNumberErrorMessage = '8 characters required';
        this.quickSearchResults[currentIndex].invalidReferenceNumber = true;
        return false;
      }
    }
  }

  parseFloatIgnoreCommas(theNumber: string): number {
    var numberNoCommas: string = theNumber.replace(/,/g, '');
    return parseFloat(numberNoCommas);
  }

  postInvoicePayment_ex(newPaymentData: InvoicePayment[]) {
    this.processedInvoicePaymentStatus = []; //reset
    let rowsInserted: number = 0;

    this.areBatchPaymentsProcessing = true; //turn on wait spinner

    this.invoiceService.postInvoicePayment_ex(newPaymentData).subscribe(
      (paymentsInserted) => {
        this.processedInvoicePaymentStatus = paymentsInserted;
      },
      (err: any) => {
        this.areBatchPaymentsProcessing = false; //turn off wait spinner
        let errorLogEntry: dbErrorEntry = new dbErrorEntry();

        errorLogEntry.Location = 'Err: qs-results-grid.ts::postInvoicePayment_ex().';
        errorLogEntry.errorMessage = JSON.stringify(err);
        this.apnUtilityService.logErrorToDB(errorLogEntry);
      },
      () => {
        let ii: number = 0;
        this.batchInvoiceErrorMessage = '';

        //Build list of invoices that returned errors
        for (ii = 0; ii < this.processedInvoicePaymentStatus.length; ii++) {
          if (this.processedInvoicePaymentStatus[ii].successStatus === false) {
            if (this.batchInvoiceErrorMessage !== '') {
              this.batchInvoiceErrorMessage += ', ';
            }
            this.batchInvoiceErrorMessage += this.processedInvoicePaymentStatus[ii].invoiceNumber;
          }
        }

        //Turn off spinner
        this.areBatchPaymentsProcessing = false;

        //Get metrics of success/failure
        let invoicesSuccessful: number = 0;
        let invoicesWithErrors: number = 0;

        for (ii = 0; ii < this.processedInvoicePaymentStatus.length; ii++) {
          let isSuccess = this.processedInvoicePaymentStatus[ii].successStatus;

          if (isSuccess) invoicesSuccessful++;
          else invoicesWithErrors++;
        }

        this.postBatchPaymentProcessing();

        if (invoicesWithErrors === 0)
          this._snackBar.open(
            this.processedInvoicePaymentStatus.length + ' payment(s) have been applied successfully. ',
            '',
            { duration: 3000 },
          );
        else
          this._snackBar.open(
            this.processedInvoicePaymentStatus.length +
              ' payment(s) were submitted, but ' +
              invoicesWithErrors +
              ' payments had errors and were not applied.',
            '',
            { duration: 3000 },
          );
      }, //end of invoice payment processing subscription
    );
  }

  postBatchPaymentProcessing(): void {
    let ii: number = 0;
    for (ii = 0; ii < this.processedInvoicePaymentStatus.length; ii++) {
      let aProcessedPayment: ProcessedInvoicePayments = this.processedInvoicePaymentStatus[ii];
      let paymentTypeName = this.getPaymentTypeByPaymentCode(aProcessedPayment.paymentCode);
      //Only add payments that were successfull
      if (aProcessedPayment.successStatus) {
        this.appliedPayments.push({
          lotNumber: aProcessedPayment.lotNumber,
          invoiceNumber: aProcessedPayment.invoiceNumber,
          paymentType: aProcessedPayment.paymentTypeText,
          referenceNumber: aProcessedPayment.referenceNumber,
          paymentAmount: aProcessedPayment.paymentAmount,
          paymentCode: aProcessedPayment.paymentCode,
          gridIndexNumber: 0,
        });

        this.updateQuickSearchResultsData(aProcessedPayment);
      } //payment wasn't applied
      else {
        this.removePendingPaymentThatHadErrorDuringPayment(aProcessedPayment.invoiceNumber);
      }

      this.changePendingPaymentStateToApplied(aProcessedPayment.invoiceNumber, aProcessedPayment.successStatus);
    } //end for loop on processedInvoicePaymentStatus
  }

  getPaymentTypeByPaymentCode(paymentCode: string): string {
    let paymentTypeText: string = '';
    let ii: number;

    for (ii = 0; ii < this.paymentTypes.length; ii++) {
      if (this.paymentTypes[ii].paymentCode.toUpperCase() === paymentCode.toUpperCase())
        paymentTypeText = this.paymentTypes[ii].paymentDescription;
    }

    return paymentTypeText;
  }

  removePendingPaymentThatHadErrorDuringPayment(invoiceNumber: string): void {
    try {
      let ii: number;
      let rowIndex: number = -1;

      for (ii = 0; ii < this.quickSearchResults.length; ii++) {
        if (this.quickSearchResults[ii].invoiceNumber === invoiceNumber) rowIndex = ii;
      }

      if (rowIndex > -1) {
        //this.pendingPayments.splice(pendingPaymentsRowIndex, 1);
        this.quickSearchResults[rowIndex].queueType = 0; //resets queue to no payment queued or paid
        this.quickSearchResults[rowIndex].paymentQueued = false;
        this.quickSearchResults[rowIndex].markedForPayment = false;
        this.quickSearchResults[rowIndex].invalidPayment = false;
        this.quickSearchResults[rowIndex].invalidReferenceNumber = false;
        this.quickSearchResults[rowIndex].currentBalance = this.quickSearchResults[rowIndex].originalBalance;
        this.quickSearchResults[rowIndex].queueType = 3;
        this.referenceNumberErrorMessage = '';

        //reset the payment type to no payment type
        var e = document.getElementById('selectPaymentType' + rowIndex) as HTMLSelectElement;
        var sel = e.selectedIndex;
        var opt = e.options[sel];
        //e.selectedIndex = 0;
        (<HTMLOptionElement>opt).value = '0';
      }
    } catch (err) {}
  }

  updateQuickSearchResultsData(aProcessedPayment: ProcessedInvoicePayments) {
    let ii: number = 0;

    for (ii = 0; ii < this.quickSearchResults.length; ii++) {
      if (this.quickSearchResults[ii].invoiceNumber === aProcessedPayment.invoiceNumber) {
        if (aProcessedPayment.successStatus) {
          this.quickSearchResults[ii].paymentApplied = true;
          this.quickSearchResults[ii].paymentAmount = aProcessedPayment.paymentAmount;
          //this.quickSearchResults[ii].currentBalance = this.quickSearchResults[i].currentBalance - invoicePaymentData.PaymentAmount;
          this.quickSearchResults[ii].referenceNumber = aProcessedPayment.referenceNumber;
          this.quickSearchResults[ii].paymentType = aProcessedPayment.paymentTypeText;
          this.quickSearchResults[ii].transactionDate = new Date();

          if (this.quickSearchResults[ii].datePaid.toString() === '0001-01-01T00:00:00')
            this.quickSearchResults[ii].datePaid = new Date();
        } else {
          this.quickSearchResults[ii].paymentApplied = false;
          this.quickSearchResults[ii].paymentAmount = 0;
          //this.quickSearchResults[ii].currentBalance = this.quickSearchResults[i].currentBalance - invoicePaymentData.PaymentAmount;
          this.quickSearchResults[ii].referenceNumber = '';
          this.quickSearchResults[ii].paymentType = '';
        }
      }
    }
  }

  changePendingPaymentStateToApplied(invoiceNumber: string, paymentSuccessful: boolean) {
    let ii: number = 0;

    for (ii = 0; ii < this.quickSearchResults.length; ii++) {
      if (this.quickSearchResults[ii].invoiceNumber === invoiceNumber) {
        this.quickSearchResults[ii].paymentApplied = paymentSuccessful;

        if (paymentSuccessful) this.quickSearchResults[ii].queueType = 2;
        else {
          this.quickSearchResults[ii].paymentQueued = false;
          this.quickSearchResults[ii].queueType = 3;
        }
      }
    }
  }

  // Get the payment override settings that enable overriding reference number, negative payment amounts
  getAdminSettingsValues() {
    this._dataService.getAdminAllSettingsStateValues().subscribe(
      (res) => {
        this.settingsStateValues = res;
      },
      (err: any) => {},
      () => {
        this._appGeneralStateService.isPaymentRefundOverrideActive = this.settingsStateValues.paymentRefundOverride;
      },
    );
  }

  reportInvoiceIssue(invoiceNumber: string) {
    const message = ''; // this is a plug in the event we want to add a message from user on issue
    this._issueNotificationService
      .reportInvoiceIssue(invoiceNumber, message)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {},
        error: (err: any) => {},
        complete: () => {
          this._messageDialogService.snackBarTopCenterTimed('This invoice has been submitted as having an issue', 3000);
        },
      });
  }
}
